import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { BestellungStatusLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MultiSelect } from '../Select/MultiSelect';

interface BestellungStatusProps {
    disabled?: boolean;
    value: string[];
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string[]) => void;
}

export const BestellungStatusMulti: React.FC<BestellungStatusProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];
        Object.keys(BestellungStatusLabel).forEach((key) => {
            list.push({
                value: key,
                label: BestellungStatusLabel[key],
            });
        });

        return list;
    }, []);

    const selectedOptions = React.useMemo(() => {
        return value.map((v) => ({
            value: v,
            label: BestellungStatusLabel[v] || v,
        }));
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Status</Label>}
            <MultiSelect
                name="status"
                isDisabled={disabled}
                value={selectedOptions}
                options={options}
                onChange={(newOptions: ValueType<SelectOption, true>): void => {
                    onChange(((newOptions || []) as SelectOption[]).map((option) => option.value));
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
